<template>
  <div class="card" v-show="currentCardId == 'license-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>免許・資格を入力</h2>
        <p>入力すると正式名称の候補が表示されます</p>
      </div>
      <div class="card-content-list">
        <LicenseRecommendChips
          :entered="enteredLicenses"
          @select="onSelectRecommend"
        />
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.licenseHistories"
              :key="item.uuid"
              :item="item"
              :length="formatData.licenseHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'免許・資格を入力'"
              suggest-license
              :descriptionMaxLength="descriptionMaxLength"
              @add-history-item="addLicenseHistory"
              @delete-history-item="deleteLicenseHistory"
              @move-history-item="moveLicenseHistory"
              @click.native="activateHistoryItem(item.uuid)"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addLicenseHistory()"
            />
          </div>
          <div
            class="attention-limit column"
            v-if="previewErrors.licenseHistory"
          >
            <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import LicenseRecommendChips from '@/components/format-edit/LicenseRecommendChips.vue'
import {
  useNewRirekishoFormatData,
  type NewRirekishoExampleSentences
} from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoHistoriesApi } from '@/composables/format-edit/useNewRirekishoHistories'

const descriptionMaxLength = 80

defineProps<{
  currentCardId?: string
  basicData: Record<string, unknown>
  previewErrors: Record<string, string>
  /** 親の各書式が全カード共通で渡す。免許カードでは例文を使わない */
  exampleSentences?: NewRirekishoExampleSentences
}>()

const formatData = useNewRirekishoFormatData()
const {
  activeHistoryItem,
  addLicenseHistory,
  deleteLicenseHistory,
  moveLicenseHistory,
  activateHistoryItem
} = useNewRirekishoHistoriesApi()

const enteredLicenses = computed(() =>
  formatData.licenseHistories.map((item) => item.description || '')
)

// 空の行があればそこへ入れ、無ければ行を足す
function onSelectRecommend(description: string) {
  const empty = formatData.licenseHistories.find((item) => !item.description)
  if (empty) empty.description = description
  else addLicenseHistory(null, { description })
}
</script>
